import appStore from 'store';
import api from './api';
import { CONTENT_TYPE } from './constants';
import LANGUAGE from 'common/languages';

const store = {
  namespaced: true,
  state: {
    contentList: [],
    detailDialogVisible: false,
    languageList: Object.keys(LANGUAGE).map(item => {
      return {
        value: item,
        label: LANGUAGE[item]
      };
    }),
    contentTypeList: Object.keys(CONTENT_TYPE).map(item => {
      return {
        value: Number(item),
        label: CONTENT_TYPE[item]
      };
    })
  },
  getters: {
    contentList: state =>
      state.contentList.map(item => {
        return {
          ...item,
          __type: CONTENT_TYPE[item.type],
          __language: LANGUAGE[item.language]
        };
      })
  },
  mutations: {
    setContentList(state, payload) {
      state.contentList = payload.slice();
    },
    toggleDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload;
    }
  },
  actions: {
    list({ commit }) {
      api.getContentList().then(({ data }) => {
        commit('setContentList', data);
      });
    },
    create({ commit }, content) { // eslint-disable-line
      return new Promise(resolve => {
        api.createContent(content).then(res => {
          resolve(res);
        });
      });
    },
    update({ commit }, content) { // eslint-disable-line
      return new Promise(resolve => {
        api.updateContent(content).then(res => {
          resolve(res);
        });
      });
    },
    remove({ commit }, id) { // eslint-disable-line
      return new Promise(resolve => {
        api.removeContent(id).then(res => {
          resolve(res);
        });
      });
    }
  }
};

appStore.registerModule('contentSetting', store);
